// Reown AppKit compatibility shim for @solana/wallet-adapter-react's
// useWallet() + useConnection(). Lets SwapWidget.jsx keep the same
// hook shape (publicKey, connected, signTransaction, connection, ...)
// while wallet connection is fully handled by Reown's unified modal.

import { useMemo } from "react";
import { PublicKey } from "@solana/web3.js";
import {
  useAppKitAccount,
  useAppKitProvider,
  useDisconnect,
} from "@reown/appkit/react";
import { useAppKitConnection } from "@reown/appkit-adapter-solana/react";

/** Same shape SwapWidget/WalletHub already consume from wallet-adapter-react. */
export function useWallet() {
  const { address, isConnected } = useAppKitAccount({ namespace: "solana" });
  const { walletProvider } = useAppKitProvider("solana");
  const { disconnect } = useDisconnect();

  return useMemo(() => {
    const publicKey = address ? new PublicKey(address) : null;
    return {
      publicKey,
      connected: !!isConnected && !!address,
      connecting: false,
      // walletProvider from AppKit exposes signTransaction / signAllTransactions
      // / signMessage for whichever wallet the user picked in the Reown modal.
      signTransaction: walletProvider?.signTransaction?.bind(walletProvider),
      signAllTransactions: walletProvider?.signAllTransactions?.bind(walletProvider),
      signMessage: walletProvider?.signMessage?.bind(walletProvider),
      wallet: walletProvider ? { adapter: { name: walletProvider.name || "Solana" } } : null,
      wallets: [],
      select: () => {},
      disconnect: () => disconnect({ namespace: "solana" }),
    };
  }, [address, isConnected, walletProvider, disconnect]);
}

export function useConnection() {
  const { connection } = useAppKitConnection();
  return { connection };
}
